import React from "react";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import { Icon, Text, Tooltip } from "@performyard/py-components";

type SettingLabelProps = {
	title: string;
	description?: string;
	tooltip?: string;
};

export const SettingLabel = ({ title, description, tooltip }: SettingLabelProps) => {
	return (
		<div className="w-[300px] space-y-2">
			<div className="flex items-center">
				<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
					{title}
				</Text>
				{tooltip ? (
					<div className="-mt-2 [&>button]:p-0">
						<Tooltip content={tooltip}>
							<Icon icon={faInfoCircle} size={12} dangerouslySetClassName="hover:text-neutral-7" />
						</Tooltip>
					</div>
				) : null}
			</div>
			<Text size="paragraph-3" weight="regular" color="neutral-9">
				{description}
			</Text>
		</div>
	);
};
